<script lang="ts" setup>
import { provideLocal } from '@vueuse/core'
import { useId } from 'reka-ui'
import { type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'
import { FORM_ITEM_INJECTION_KEY } from './injectionKeys'
import { useFormField } from './useFormField'

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const id = useId()
provideLocal(FORM_ITEM_INJECTION_KEY, id)

const { name } = useFormField()
</script>

<template>
  <div class="atabix-input-item" :class="cn('space-y-2', props.class)" :data-test-form-item="name">
    <slot />
  </div>
</template>
